import React from 'react';
import {
  Card,
  CardBody,
  CardFooter,
  CardFooterRow,
  CardFooterColumn,
  Tag,
} from '../card';
import Price from '../../containers/price';
import QuantityManipulator from '../../containers/quantitymanipulator';
import { Heading, Text } from '../misc';
import Image, { LoadingImage } from '../image';

const Article = ({ searching, item, toggleArticleDetail }) => {
  return (
    <Card>
      <CardBody id="card-body">
        {!searching ? (
          <Image
            onClick={() => toggleArticleDetail(item)}
            src={`${process.env.REACT_APP_BASE_IMAGE_PATH_LARGE}${
              item.articleID
            }.jpg`}
          />
        ) : (
          <LoadingImage />
        )}
      </CardBody>
      <CardFooter>
        <div
          css={`
            position: absolute;
            right: 16px;
            top: -12px;
            width: 50%;
            background-color: #fff;
            padding: 0 16px;
          `}
        >
          <Tag available={item.is_available}>
            {item.is_available
              ? 'Verfügbar'
              : `Lieferzeit: ${item.delivery_time_in_days} Tage`}
          </Tag>
        </div>
        <CardFooterRow>
          <CardFooterColumn>
            <Heading>{item.articleID}</Heading>
            <Text>{item.type}</Text>
          </CardFooterColumn>
          <CardFooterColumn>
            <Price prices={item.prices} />
          </CardFooterColumn>
        </CardFooterRow>
        <CardFooterRow
          style={{
            display: 'block',
          }}
        >
          <QuantityManipulator articleID={item.articleID} />
        </CardFooterRow>
      </CardFooter>
    </Card>
  );
};

export default Article;



// WEBPACK FOOTER //
// ./src/components/article/index.js